const views = {
  SUBSCRIPTION: 'subscription',
  SCHEDULE: 'schedule',
  SHIP: 'ship',
  PAY: 'pay',
} as const;

const SUSBSCRIPTION_STORAGE_ID = 'subscription';
const SUSBSCRIPTION_STORAGE_EXPIRATION_DAYS = 365;
const COMMENT_ID = 'comment';
const BOX_REQUEST_STORAGE_ID = 'box_request';
const NEXT_BOX_DATE_ID = 'next-box-date';

const TEXT = {
  TOAST: {id: 'mgm.suscription.toast'},
};

export {
  views,
  BOX_REQUEST_STORAGE_ID,
  NEXT_BOX_DATE_ID,
  COMMENT_ID,
  SUSBSCRIPTION_STORAGE_ID,
  SUSBSCRIPTION_STORAGE_EXPIRATION_DAYS,
  TEXT,
};
